import React from 'react'
import { withRouter } from 'react-router-dom'

import { Toast } from 'primereact/toast'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'

import TipoGarantiaService from '../../app/service/TipoGarantiaService'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import NavBar from '../../componentes/Navbar'
import Progresso from '../../componentes/Progresso'

class TipoGarantia extends React.Component {

  constructor(props) {
    super(props);

    this.tipoGarantiaService = new TipoGarantiaService();
    this.accept = this.accept.bind(this);
    this.renderFooterCadastroGarantia = this.renderFooterCadastroGarantia.bind(this);
    this.renderFooterAlterarGarantia = this.renderFooterAlterarGarantia.bind(this);
    this.acoes = this.acoes.bind(this);

    this.state = {
      //Cadastro
      codigo: '',
      nome: '',
      empresa: null,
      garantias: [],
      modalCadastro: false,
      modalAlterar: false,
      visivble: false,
      //Progresso
      classeDiv: 'hide'
    };
  }

  fecharModalCadastro(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModalCadastro(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.limparCampos();
    this.setState(state);
  }

  abrirModaAlterar(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }

    this.setState(state);
  }

  limparCampos = () => {
    this.setState({nome: ''});
  }

  accept() {
    this.excluirGarantia();
  }

  listarGarantias = async() => {
    this.setState({classeDiv: 'show'});
    const usuarioLogado = this.context.usuarioAutenticado
    await this.tipoGarantiaService.listarGarantias(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({garantias: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Garantias de Processo', detail:`${this.state.detail}`, life: 4000});
      });

      this.setState({classeDiv: 'hide'});
  }

  cadastrarGarantias = async() => {
    this.setState({classeDiv: 'show'});

    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Garantias de Processo', detail:'Informe o nome da Garantia de Processo', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    const usuarioLogado = this.context.usuarioAutenticado

    await this.tipoGarantiaService.cadastrarGarantia({
      nome: this.state.nome,
      empresa: usuarioLogado.empresa
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Garantias de Processo', detail:'Garantia de Processo cadastrada com sucesso', life: 4000});
      this.listarGarantias();
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Garantias de Processo', detail:`${this.state.detail}`, life: 4000});
    });

    this.fecharModalCadastro('modalCadastro');
    this.setState({classeDiv: 'hide'});
  }

  async editar(garantia) {
    this.setState({classeDiv: 'show'});
    if(garantia != null) {
      await this.tipoGarantiaService.consultarGarantia(garantia.codigo)
        .then(response => {
          this.setState({codigo: response.data.codigo,
                         nome: response.data.nome});
          this.abrirModaAlterar('modalAlterar');
        }).catch(error => {
          this.setState(error.response.data);
          this.toast.show({severity:'error', summary: 'Garantias de Processo', detail:`${this.state.detail}`, life: 4000});
        });

        this.setState({classeDiv: 'hide'});
    }

    this.setState({classeDiv: 'hide'});
  }

  alterarGarantia = async() => {
    this.setState({classeDiv: 'show'});

    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Garantias de Processo', detail:'Informe o nome da Garantia de Processo', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    const usuarioLogado = this.context.usuarioAutenticado

    await this.tipoGarantiaService.alterarGarantia({
      codigo: this.state.codigo,
      nome: this.state.nome,
      empresa: usuarioLogado.empresa
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Garantias de Processo', detail:'Garantia de Processo alterada com sucesso', life: 4000});
      this.listarGarantias();
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Garantias de Processo', detail:`${this.state.detail}`, life: 4000});
    });

    this.fecharModalCadastro('modalAlterar');
    this.setState({classeDiv: 'hide'});
  }

  confirmaExclusao(garantia) {
    this.setState({codigo: garantia.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir a Garantia de Sucesso?',
        header: 'Exclusão de Garantia de Sucesso',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.accept,
        reject: this.reject
    });
  }

  excluirGarantia = async() => {
    this.setState({classeDiv: 'show'});
    await this.tipoGarantiaService.excluirGarantia(this.state.codigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Garantias de Processo', detail:'Garantia de Processo excluído com sucesso', life: 4000});
        this.listarGarantias();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Garantias de Processo', detail:`${this.state.detail}`, life: 4000});
      });

      this.setState({classeDiv: 'hide'});
  }

  renderFooterCadastroGarantia(name) {
    return (
        <div>
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModalCadastro(name)}/>
              
            &nbsp;
            <Button label="Cadastrar" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarGarantias}/> 
        </div>
    );
  }

  renderFooterAlterarGarantia(name) {
    return (
        <div>
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModalCadastro(name)}/>
              
            &nbsp;
            <Button label="Alterar" 
                    className="p-button-primary p-button-text"
                    onClick={this.alterarGarantia}/> 
        </div>
    );
  }

  acoes(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
                onClick={() => this.editar(rowData)}
                tooltip="Editar Garantia de Processo" 
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmaExclusao(rowData)} 
                tooltip="Excluir Garantia de Processo" 
                tooltipOptions={{position: 'top'}}/>
      </React.Fragment>
    );
  }

  componentDidMount() {
    this.listarGarantias();
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <div className="content-wrapper">
          {/**Cadastro de Garantias de Processo */}
          <Dialog header="Cadastro de Garantias de Processo"
                    visible={this.state.modalCadastro} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterCadastroGarantia('modalCadastro')} 
                    onHide={() => this.fecharModalCadastro('modalCadastro')}>
                
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nomeGarantia">Nome</label>
                        <InputText id="nomeGarantia" 
                                   type="text" 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
          </Dialog>
          {/**Alterar Garantias de Processo */}
          <Dialog header="Alterar Garantias de Processo"
                    visible={this.state.modalAlterar} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterAlterarGarantia('modalAlterar')} 
                    onHide={() => this.fecharModalCadastro('modalAlterar')}>
                
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nomeGarantiaAlterar">Nome</label>
                        <InputText id="nomeGarantiaAlterar" 
                                   type="text" 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
          </Dialog>
          <ConfirmDialog visible={this.state.visible} 
                         onHide={() => this.setState({ visible: false })} 
                         message="Are you sure you want to proceed?"
                         header="Confirmation"
                         icon="pi pi-exclamation-triangle" 
                         accept={() => this.excluirGarantia} 
                         reject={() => this.setState({visible: false})}/>
          <section className="content-header">
            <div className="container-fluid">
            <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary card-outline">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="fas fa-university"></i>
                        <span> Garantias de Processo</span>
                      </h3>  
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-5">
                          <span className="input-group">
                            <button type="button" className="btn btn-primary bg-gradient-primary" 
                                    onClick={() => this.abrirModalCadastro('modalCadastro')}
                                    data-toggle="modal" 
                                    data-target="#modal-default">
                            <i className="fas fa-plus"></i> Adicionar</button>
                          </span>
                        </div>
                      </div>
                    <Progresso classeSecundaria={this.state.classeDiv}/>
                    </div>
                    <DataTable value={this.state.garantias}  paginator responsiveLayout="scroll"
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}>
                      <Column field="nome" header="Nome"></Column>
                      <Column key="codigo"></Column>
                      <Column body={this.acoes} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}

TipoGarantia.contextType = AuthContext;
export default withRouter (TipoGarantia)
